/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdContactDataQueryResponse,
  GetApiV1PersonIdContactDataPathParams,
  GetApiV1PersonIdContactData401,
  GetApiV1PersonIdContactData404,
  GetApiV1PersonIdContactData500,
} from "../../types/personRegisterController/GetApiV1PersonIdContactData.ts";

function getGetApiV1PersonIdContactDataUrl(
  id: GetApiV1PersonIdContactDataPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/contact-data` as const,
  };
  return res;
}

/**
 * @description Retorna os dados de contato de uma pessoa (telefones, preferências de comunicação). **(Requer Authorization para autenticação)**
 * @summary Obter dados de contato (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/contact-data}
 */
export async function getApiV1PersonIdContactData(
  id: GetApiV1PersonIdContactDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdContactDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdContactData401
      | GetApiV1PersonIdContactData404
      | GetApiV1PersonIdContactData500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdContactDataUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
